// TODO fix imports(ui component should not be dependent on anything from outside ui)
// TODO there is already FileIcon.tsx in `feed/components`
// TODO: try to solve different imports in different files - 82948
import { type FileAsset, FileType, type FolderAsset, FolderType } from 'models/asset';
import { Icon, type IconProperties } from '../icon';

type P = {
  asset: FileAsset | FolderAsset;
  size?: IconProperties['size'];
};

const FileIconDeprecated = ({ asset, size = 'middle' }: P) => {
  if (asset.type === FolderType) {
    return <Icon icon="folder" size={size} />;
  }

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  if (asset.type === FileType) {
    if (asset.contentType.includes('image')) {
      return <Icon icon="img-file" size={size} />;
    }

    if (asset.contentType.includes('pdf')) {
      return <Icon icon="pdf-file" size={size} />;
    }

    if (asset.contentType.includes('spreadsheetml')) {
      return <Icon icon="sheet-file" size={size} />;
    }

    if (['wordprocessingml', 'msword'].some((word) => asset.contentType.includes(word))) {
      return <Icon icon="document-file" size={size} />;
    }
  }

  return <Icon icon="default-file" size={size} />;
};

export default FileIconDeprecated;
